/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {SearchResource} from '../../components/api/resources/resource/search';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {getCountryEntry} from '../common/directives/country-select/countries';

@Injectable({providedIn: 'root'})
export class SearchCoordinatorService {
  resolved = false;
  aggregations: any[] = [];
  searchResults: any = {
    items: []
  };

  constructor(
    private readonly searchResource: SearchResource,
    private readonly localUserProfile: LocalUserProfile
  ) {
  }

  sync(params: any, searchMeta?: any): Promise<any> {
    this.resolved = false;
    searchMeta = searchMeta || {};
    const searchParams = _.merge({}, params, searchMeta);
    searchMeta.resolved = false;
    searchParams.page = searchMeta.currentPage - 1 || 0;

    return this.searchResource.query(searchParams).then((data: any) => {
      const aggregations = _.filter(data.aggregations, (aggregation: any, name: string) => {
        aggregation.name = name;
        aggregation.buckets = _.isArray(aggregation.buckets)
          ? aggregation.buckets
          : (_.isObject(aggregation.buckets) ? _.values(aggregation.buckets) : []);

        if (aggregation.name === 'country') {
          _.forEach(aggregation.buckets, (bucket: any) => {
            bucket.name = (getCountryEntry(bucket.name) || {}).name || bucket.name;
          });
        }

        if (this.localUserProfile.get().app === 'DATA') {
          _.forEach(aggregation.buckets, (bucket: any) => {
            bucket.name = bucket.name === 'UserSegment' ? 'Segment' : bucket.name;
          });
        }

        return !_.isEmpty(aggregation.buckets);
      });

      this.aggregations.length = 0;
      this.aggregations.push(...aggregations);

      const results = {
        items: data.searchResults,
        totalHits: data.totalHits,
        pageStart: data.pageStart,
        pageEnd: data.pageEnd
      };

      searchMeta.resolved = true;
      this.resolved = true;
      this.searchResults.items = results.items;
      this.searchResults.totalHits = results.totalHits;
      this.searchResults.pageStart = results.pageStart;
      this.searchResults.pageEnd = results.pageEnd;
      return this;
    });
  }
}
